<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>{{ modalTitle }}</h3>
        <form @submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="form-group">
            <label>{{ $t('title') }}</label>
            <input v-model="form.title" type="text" class="form-control" >
          </div>

          <div class="form-group">
            <label>{{ $t('category') }}</label>
            <select v-model="form.income_category_id" class="form-control" required>
              <option v-for="cat in categories" :value="cat.id" :key="cat.id">
                {{ cat.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('project') }}</label>
            <select v-model="form.project_id" @change="onProjectChange" class="form-control">
              <option value="">Select Project</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ project.title }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('client') }}</label>
            <select v-model="form.client_id" class="form-control" :disabled="!form.project_id">
              <option value="">Select Client</option>
              <option v-for="client in clients" :key="client.id" :value="client.id">
                {{ client.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('amount') }}</label>
            <input type="number" v-model="form.amount" class="form-control" required>
          </div>

          <div class="form-group">
            <label>{{ $t('date') }}</label>
            <input type="date" v-model="form.date" class="form-control">
          </div>

          <div class="form-group">
            <label>{{ $t('reference') }}</label>
             <input v-model="form.reference" type="text" class="form-control" >
          </div>

          <div class="form-group">
            <label>{{ $t('description') }}</label>
            <textarea v-model="form.description" class="form-control"></textarea>
          </div>

          <div class="form-group">
            <label>{{ $t('file') }}</label>
            <input type="file" @change="handleFileUpload" class="form-control" />
            <div v-if="form.file_path">
              <a :href="form.file_path" target="_blank">Download current file</a>
            </div>
          </div>

          <div class="text-end mt-3">
            <button 
              class="btn btn-primary" 
              type="submit" 
              :disabled="isSubmitting">
              {{ isSubmitting ? $t('saving') + '...' : $t('save') }}
            </button>
            <button class="btn btn-secondary" type="button" @click="$emit('input', false)" :disabled="isSubmitting">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    income: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        title: '',
        income_category_id: '',
        project_id: '',
        client_id: '',
        amount: '',
       reference: '',
        description: '',
        date: '',
        file: null,
        file_path: ''  // existing file link
      },
      categories: [],
      projects: [],
      clients: [],
      isSubmitting: false
    }
  },
  watch: {
    income: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            title: newVal.title,
            income_category_id: newVal.income_category_id,
            project_id: newVal.project_id || '',
            client_id: newVal.client_id || '',
            amount: newVal.amount,
             reference: newVal.reference,
            description: newVal.description,
            date: newVal.date ? newVal.date.slice(0, 10) : '',
            file: null,
            file_path: newVal.file ? '/' + newVal.file : ''
          }
          // Load clients for the selected project if exists
          if (this.form.project_id) {
            this.fetchClients(this.form.project_id)
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.income ? 'Edit Income' : 'Add Income'
    }
  },
  mounted() {
    axios.get('/income-categories').then(res => {
      this.categories = res.data
    })
    axios.get('/incomes/projects').then(res => {
      this.projects = res.data
    })
  },
  methods: {
    resetForm() {
      this.form = {
        title: '',
        income_category_id: '',
        project_id: '',
        client_id: '',
        amount: '',
         reference: '',
        description: '',
        date: '',
        file: null,
        file_path: ''
      }
      this.clients = []
    },
    onProjectChange() {
      // Reset client when project changes
      this.form.client_id = ''
      if (this.form.project_id) {
        this.fetchClients(this.form.project_id)
      } else {
        this.clients = []
      }
    },
    fetchClients(projectId) {
      axios.get('/incomes/clients', {
        params: { project_id: projectId }
      }).then(res => {
        this.clients = res.data
      }).catch(err => {
        console.error(err)
        this.clients = []
      })
    },
    handleFileUpload(e) {
      this.form.file = e.target.files[0]
    },
    submitForm() {
      this.isSubmitting = true
      const url = this.income ? `/incomes/${this.income.id}` : '/incomes'
      const formData = new FormData()
      for (const key in this.form) {
        if (this.form[key] !== null) formData.append(key, this.form[key])
      }
      if (this.income) formData.append('_method', 'PUT')

      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(() => {
          this.$emit('input', false)
          this.$emit('saved')
          this.resetForm()
        })
        .catch(err => {
          console.error(err)
          Swal.fire({
            title: 'Error!',
            text: 'Error saving income information.',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 500px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>
